/* eslint-disable @next/next/no-img-element */
import Link from 'next/link'

export const NotFoundPage = () => {
  return (
    <div className='not-found container'>
      <div className='box'>
        <div className='logo'>
          <img src='https://cinestar.com.vn/pictures/logo/den.png' alt='logo-cinestar' />
          </div>        
          <div className='content'>
              <p>The page you requested cannot be found!</p>
          </div>
          <div className='url-back'>
              <p>Click here go back. <Link href={"/"} >Home</Link></p>
          </div>      
        </div>
    </div>
  )
}
